import React from "react";

export default function IPEExecutionDashboard() {
  return (
    <div>
      <h2>IPEExecutionDashboard</h2>
      <p>Coming Soon...</p>
    </div>
  );
}